/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

/**
 * Defines the module for the analytics utility dependencies.
 */
const commonModule = require('@utils/common/commonModule');
const consumersModule = require('@utils/consumers/consumersModule');
const AnalyticsService = require('./analyticsService');

const analyticsModule = angular
    .module('enervee_utils.analytics', [
        commonModule.name,
        consumersModule.name,
    ])
    .factory('AnalyticsService', AnalyticsService);

module.exports = analyticsModule;